module.exports = __webpack_public_path__ + "static/img/qrcode_siji.675c550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode_siji.png
// module id = oQii
// module chunks = 1